import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import TabsListLayout from '../components/layout/tabs-list-layout';
import TabsList from '../components/tabs-list';
import { VARIANTS } from '../components/tabs-list/constants';
import TabsContext from '../context/tabs-context';

const TabsListContainer = ({ children, variant = VARIANTS.scrollable }) => {
  const { appearance, activeTabId, activeTabManager, noBackground } = useContext(TabsContext);

  return (
    <TabsListLayout>
      <TabsList
        appearance={appearance}
        variant={variant}
        activeTabManager={activeTabManager}
        activeTabId={activeTabId}
        noBackground={noBackground}
      >
        {children}
      </TabsList>
    </TabsListLayout>
  );
};

export default TabsListContainer;

TabsListContainer.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(Object.values(VARIANTS)),
};
